export default {"src":"/_next/static/media/calendar-right-arrow.8e086438.svg","height":14,"width":8,"blurWidth":0,"blurHeight":0};